<template>
  <div>
    <h1>The page you are looking for does not exist.</h1>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
